<header class="header-route">
  <img
    src="/assets/icons/arrow-left.svg"
    [alt]="'COMMONS.EXIT' | i18nextEager"
    (click)="handleGoBack()"
    class="arrow"
  />
  <img src="/assets/icons/logo.svg" class="element" [alt]="'COMMONS.ACCIONA_LOGO' | i18nextEager" />
  <div class="container-title element">
    <h5>green energy</h5>
    <span class="separator"></span>
    <span class="subtitle">{{ 'RENOVATE_COTRACT.TITLE' | i18nextEager | uppercase }}</span>
  </div>
  <div class="space"></div>
  <div class="icon" [ngClass]="{ 'separator-icon': !fromPending, 'margin-right': tabIndex === 1 && fromPending }">
    <img
      src="/assets/icons/delete.svg"
      [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
      *ngIf="(tabIndex === 1 && !idContract) || (tabIndex === 0 && !contractDraft?.idBorrador); else elseBlock"
    />
    <ng-template #elseBlock>
      <img
        src="/assets/icons/deleteRed.svg"
        [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
        class="cursor-pointer"
        (click)="deleteContract()"
      />
    </ng-template>
  </div>
  <div *ngIf="tabIndex !== 1" class="separator-icon icon">
    <img *ngIf="!canSave" src="/assets/icons/save_gray.svg" [alt]="'COMMONS.SAVE' | i18nextEager" />
    <img
      *ngIf="canSave"
      src="/assets/icons/save_red.svg"
      [alt]="'COMMONS.SAVE' | i18nextEager"
      class="cursor-pointer"
      (click)="handleSave(false)"
    />
  </div>
  <div *ngIf="!fromPending" class="icon" [ngClass]="{ 'margin-right': tabIndex === 1 }">
    <img
      [src]="'/assets/icons/progress-' + progress + '.svg'"
      [alt]="'COMMONS.PROGRESS' | i18nextEager"
      (click)="handleOpenProgress()"
      class="cursor-pointer"
    />
  </div>
  <button *ngIf="tabIndex !== 1" (click)="handleGoNext()" [disabled]="!goNext" class="margin-right">
    {{ 'COMMONS.NEXT' | i18nextEager }}
  </button>
</header>
<div class="renovate-contract-pymes__container">
  <div class="renovate-contract-pymes__loader" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <mat-tab-group [selectedIndex]="tabIndex" [disableRipple]="true" class="renovate-contract-pymes__stepper">
    <mat-tab [aria-labelledby]="'active'" [disabled]="true">
      <app-renovate-contract-pymes-form
        *ngIf="dataContract"
        [dataContract]="dataContract"
        (canSave)="handleCanSave($event)"
      ></app-renovate-contract-pymes-form>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex > 0 ? 'active' : null" [disabled]="true">
      <app-contract-signing
        *ngIf="tabIndex === 1"
        [hasChangedDni]="hasChangedDni"
        [hasChangedBankAccount]="hasChangedBankAccount"
        [hasSepaFile]="hasSepaFile"
        [hasContractFile]="hasContractFile"
        [finishCreateFiles]="asyncContractRenovated"
        (isLoading)="changeLoader($event)"
      ></app-contract-signing>
    </mat-tab>
  </mat-tab-group>
</div>
